// extracted by mini-css-extract-plugin
export default {"button":"Button_button__zCmc2","blue":"Button_blue__x9LjB","grey":"Button_grey__QGz7+","green":"Button_green__ymwv6"};